import type { DataListExtraOptionWrite, DataListOptionValueOverrideWrite } from "./useUpsertDataListValueOverride";

export const normalizeDataListExtraOptionCode = (code: string): string => {
    const trimmed = code.trim();

    if (trimmed.toLowerCase().startsWith("extra:")) {
        return trimmed.slice(6);
    }

    return trimmed;
};

type MergeableChildren = {
    dataListOptionValueOverrides: DataListOptionValueOverrideWrite[];
    dataListExtraOptions: DataListExtraOptionWrite[];
};

export const mergeDataListValueOverrideChildren = (
    existing: MergeableChildren,
    incoming: MergeableChildren,
): MergeableChildren => {
    const optionOverridesByCode = new Map<string, DataListOptionValueOverrideWrite>();

    for (const optionOverride of existing.dataListOptionValueOverrides) {
        optionOverridesByCode.set(optionOverride.dataListOptionCode, optionOverride);
    }

    for (const optionOverride of incoming.dataListOptionValueOverrides) {
        const existingOptionOverride = optionOverridesByCode.get(optionOverride.dataListOptionCode);

        optionOverridesByCode.set(optionOverride.dataListOptionCode, {
            ...existingOptionOverride,
            ...optionOverride,
            dataListOptionCode: optionOverride.dataListOptionCode,
        });
    }

    const extraOptionsByCode = new Map<string, DataListExtraOptionWrite>();

    for (const extraOption of existing.dataListExtraOptions) {
        extraOptionsByCode.set(normalizeDataListExtraOptionCode(extraOption.code), extraOption);
    }

    for (const extraOption of incoming.dataListExtraOptions) {
        const code = normalizeDataListExtraOptionCode(extraOption.code);
        const existingExtraOption = extraOptionsByCode.get(code);

        extraOptionsByCode.set(code, {
            ...existingExtraOption,
            ...extraOption,
            code,
        });
    }

    return {
        dataListOptionValueOverrides: [...optionOverridesByCode.values()],
        dataListExtraOptions: [...extraOptionsByCode.values()],
    };
};
